import HttpApi, { HttpApiRequestOptions, HttpApiResult } from './HttpApi';
import GenericBaseResponseDTO from '../models/validation/GenericBaseResponseDTO';
import BaseResponseDTO from '../models/validation/BaseResponseDTO';
import UpdateClientSubscriptionDTO from '../models/client/UpdateClientSubscriptionDTO';
import UpdateClientDTO from '../models/client/UpdateClientDTO';
import KeyValueDTO from '../models/generic/KeyValueDTO';
import ClientDTO from '../models/client/ClientDTO';
import TableResponseDTO from '../models/datatable/TableResponseDTO';
import ClientSubscriptionDTO from '../models/client/ClientSubscriptionDTO';
import AddClientDTO from '../models/client/AddClientDTO';
import AddClientSubscriptionDTO from '../models/client/AddClientSubscriptionDTO';
import TableRequestDTO from '../models/datatable/TableRequestDTO';
import UpdateDistrictDTO from 'src/models/district/UpdateDistrictDTO';

export class ClientApiController {
    // post: Client/AddClient
    public RouteAddClient = () => `Client/AddClient`;
    public addClient(addClientDTO: AddClientDTO, requestOptions?: HttpApiRequestOptions): Promise<HttpApiResult<GenericBaseResponseDTO<number>>> {
        let url = this.RouteAddClient();
        return HttpApi.RestRequest<any, GenericBaseResponseDTO<number>>(addClientDTO, 'post', url, requestOptions);
    }
    // post: Client/UpdateClient
    public RouteUpdateClient = () => `Client/UpdateClient`;
    public updateClient(updateClientDTO: UpdateClientDTO, requestOptions?: HttpApiRequestOptions): Promise<HttpApiResult<void>> {
        let url = this.RouteUpdateClient();
        return HttpApi.RestRequest<any, void>(updateClientDTO, 'post', url, requestOptions);
    }
    // post: Client/AddClientSubscription
    public RouteAddClientSubscription = () => `Client/AddClientSubscription`;
    public addClientSubscription(addClientSubscriptionDTO: AddClientSubscriptionDTO, requestOptions?: HttpApiRequestOptions): Promise<HttpApiResult<void>> {
        let url = this.RouteAddClientSubscription();
        return HttpApi.RestRequest<any, void>(addClientSubscriptionDTO, 'post', url, requestOptions);
    }
    // post: Client/UpdateClientSubscription
    public RouteUpdateClientSubscription = () => `Client/UpdateClientSubscription`;
    public updateClientSubscription(updateClientSubscriptionDTO: UpdateClientSubscriptionDTO, requestOptions?: HttpApiRequestOptions): Promise<HttpApiResult<BaseResponseDTO>> {
        let url = this.RouteUpdateClientSubscription();
        return HttpApi.RestRequest<any, BaseResponseDTO>(updateClientSubscriptionDTO, 'post', url, requestOptions);
    }
    // get: Client/GetClientSubscription/${clientSubscriptionId}
    public RouteGetClientSubscription = (clientSubscriptionId: number) => `Client/GetClientSubscription/${clientSubscriptionId}`;
    public getClientSubscription(clientSubscriptionId: number, requestOptions?: HttpApiRequestOptions): Promise<HttpApiResult<UpdateClientSubscriptionDTO>> {
        let url = this.RouteGetClientSubscription(clientSubscriptionId);
        return HttpApi.RestRequest<any, UpdateClientSubscriptionDTO>(null, 'get', url, requestOptions);
    }
    // get: Client/GetClient/${clientId}
    public RouteGetClient = (clientId: number) => `Client/GetClient/${clientId}`;
    public getClient(clientId: number, requestOptions?: HttpApiRequestOptions): Promise<HttpApiResult<UpdateClientDTO>> {
        let url = this.RouteGetClient(clientId);
        return HttpApi.RestRequest<any, UpdateClientDTO>(null, 'get', url, requestOptions);
    }
    // get: Client/GetClientTypes
    public RouteGetClientTypes = () => `Client/GetClientTypes`;
    public getClientTypes(requestOptions?: HttpApiRequestOptions): Promise<HttpApiResult<KeyValueDTO<string, number>[]>> {
        let url = this.RouteGetClientTypes();
        return HttpApi.RestRequest<any, KeyValueDTO<string, number>[]>(null, 'get', url, requestOptions);
    }
    // post: Client/GetClientTableData
    public RouteGetClientTableData = () => `Client/GetClientTableData`;
    public getClientTableData(tableRequest: TableRequestDTO, requestOptions?: HttpApiRequestOptions): Promise<HttpApiResult<TableResponseDTO<ClientDTO>>> {
        let url = this.RouteGetClientTableData();
        return HttpApi.RestRequest<any, TableResponseDTO<ClientDTO>>(tableRequest, 'post', url, requestOptions);
    }
    // post: Client/GetClientSubscriptionTableData?clientId=${clientId}
    public RouteGetClientSubscriptionTableData = (clientId: number) => `Client/GetClientSubscriptionTableData?clientId=${clientId}`;
    public getClientSubscriptionTableData(tableRequest: TableRequestDTO, clientId: number, requestOptions?: HttpApiRequestOptions): Promise<HttpApiResult<TableResponseDTO<ClientSubscriptionDTO>>> {
        let url = this.RouteGetClientSubscriptionTableData(clientId);
        return HttpApi.RestRequest<any, TableResponseDTO<ClientSubscriptionDTO>>(tableRequest, 'post', url, requestOptions);
    }
    // get: Client/GetAllClients
    public RouteGetAllClients = () => `Client/GetAllClients`;
    public getAllClients(requestOptions?: HttpApiRequestOptions): Promise<HttpApiResult<KeyValueDTO<number, string>[]>> {
        let url = this.RouteGetAllClients();
        return HttpApi.RestRequest<any, KeyValueDTO<number, string>[]>(null, 'get', url, requestOptions);
    }
    // post: Client/CheckCleverId
    public RouteIsDuplicateCleverDistrictId = () => `Client/CheckCleverId`;
    public isDuplicateCleverDistrictId(updateClientDTO: UpdateClientDTO, requestOptions?: HttpApiRequestOptions): Promise<HttpApiResult<boolean>> {
        let url = this.RouteIsDuplicateCleverDistrictId();
        return HttpApi.RestRequest<any, boolean>(updateClientDTO, 'post', url, requestOptions);
    }
    // post: Client/CheckClassLinkTenantId
    public RouteIsDuplicateClassLinkTenantId = () => `Client/CheckClassLinkTenantId`;
    public isDuplicateClassLinkTenantId(updateClientDTO: UpdateClientDTO, requestOptions?: HttpApiRequestOptions): Promise<HttpApiResult<boolean>> {
        let url = this.RouteIsDuplicateClassLinkTenantId();
        return HttpApi.RestRequest<any, boolean>(updateClientDTO, 'post', url, requestOptions);
    }
    // post: Client/District/CheckCleverId
    public RouteDistrictIsDuplicateCleverDistrictId = () => `Client/District/CheckCleverId`;
    public isDistrictDuplicateCleverDistrictId(updateDistrictDTO: UpdateDistrictDTO, requestOptions?: HttpApiRequestOptions): Promise<HttpApiResult<boolean>> {
        let url = this.RouteDistrictIsDuplicateCleverDistrictId();
        return HttpApi.RestRequest<any, boolean>(updateDistrictDTO, 'post', url, requestOptions);
    }
    // post: Client/District/CheckClassLinkTenantId
    public RouteDistrictIsDuplicateClassLinkTenantId = () => `Client/District/CheckClassLinkTenantId`;
    public isDistrictDuplicateClassLinkTenantId(updateDistrictDTO: UpdateDistrictDTO, requestOptions?: HttpApiRequestOptions): Promise<HttpApiResult<boolean>> {
        let url = this.RouteDistrictIsDuplicateClassLinkTenantId();
        return HttpApi.RestRequest<any, boolean>(updateDistrictDTO, 'post', url, requestOptions);
    }
}
var service = new ClientApiController();
export default service;



// WEBPACK FOOTER //
// ./src/api/ClientApiController.ts